/* src/app/components/print-product-modal/print-product-modal.component.scss */
.header {
  background-color: white;
}
.header ion-icon {
  width: 24px;
  height: 24px;
  color: black;
}
.header h1 {
  font-family: "Barlow Semi Condensed";
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.header ion-button {
  margin: 0;
  min-height: 0;
}
.header ion-button::part(native) {
  padding: 0;
}
.header ion-button ion-icon {
  width: 32px;
  height: 32px;
}
.content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  overflow-y: auto;
  height: 100%;
  background-color: #f6f6f6;
}
.fileCount {
  color: #949494;
  font-family: "Barlow Semi Condensed";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.price {
  color: #949494;
  font-family: "Barlow Semi Condensed";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.qtyCounter label {
  font-family: "Barlow Semi Condensed";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  color: black;
}
.qtyCounter span {
  color: #259dff;
  font-family: "League Spartan";
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.binding-settings {
  border-radius: 10px;
  border: 1px solid #cbcbcb;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  color: black;
  font-family: "Barlow Semi Condensed";
}
.ring-img {
  width: 20px;
  height: 20px;
}
.cover-img {
  width: 20px;
  height: 24px;
}
.files-container {
  border-radius: 15px;
  border: 1px solid #949494;
  background-color: white;
}
.footer {
  background-color: white;
}
.footer ion-button {
  margin: 0;
  min-height: 0;
}
.footer ion-button:first-of-type {
  --background: #f6f6f6;
  --background-hover: #cbcbcb;
  --bacground-activated: #cbcbcb;
  color: black;
  font-family: "Barlow Semi Condensed";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.footer ion-button:first-of-type ion-icon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}
.footer ion-button:first-of-type::part(native) {
  border-radius: 15px;
  padding: 14px 18px;
  background-color: #f6f6f6;
}
.footer ion-button:last-of-type {
  --background: white;
  --border-radius: 10px;
  --box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.footer ion-button:last-of-type::part(native) {
  max-width: 52px;
  aspect-ratio: 1/1;
}
.footer ion-button:last-of-type ion-icon {
  width: 22px;
  height: 22px;
}
ion-popover {
  --width: auto;
}
ion-popover::part(content) {
  border-radius: 15px;
}
ion-popover.warning-popover {
  --max-width: 340px;
}
ion-popover.warning-popover::part(content) {
  border-radius: 20px;
  padding: 20px;
}
ion-popover.warning-popover .warning-title {
  color: #949494;
  font-family: "Barlow Semi Condensed";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
ion-popover.warning-popover .warning-message {
  border-radius: 15px;
  border: 2px solid #f5b200;
  background:
    linear-gradient(
      0deg,
      rgba(245, 178, 0, 0.1) 0%,
      rgba(245, 178, 0, 0.1) 100%),
    #fff;
  padding: 12px 15px;
  align-items: center;
  width: fit-content;
  position: sticky;
  top: 0;
  z-index: 9;
  color: #d59b00;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
  white-space: pre-wrap;
  text-align: start;
}
ion-popover.warning-popover .warning-message ion-icon {
  width: 30px;
  height: 30px;
}
.divider {
  height: 1px;
  width: 100%;
  background-color: #cbcbcb;
}
.binding-label {
  border-radius: 20px;
  background-color: #fff0c6;
  padding: 5px 8px;
  color: #d59b00;
  text-align: center;
  font-family: "Barlow Semi Condensed";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.warning-icon {
  cursor: pointer;
  border-radius: 15px;
  border: 2px solid #f5b200;
  background:
    linear-gradient(
      0deg,
      rgba(245, 178, 0, 0.1) 0%,
      rgba(245, 178, 0, 0.1) 100%),
    #fff;
  padding: 8px 10px;
  width: 24px;
  height: 24px;
  color: #d59b00;
}
.file-info-wrapper {
  border-radius: 15px;
  background-color: #f6f6f6;
  padding: 10px;
}
.file-info-container {
  border-radius: 10px;
  border: 1px solid #949494;
  background-color: white;
  padding: 10px;
}
.file-info-container .blank-sheets-text {
  color: black;
  font-family: "Barlow Semi Condensed";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}
.file-info-container .blank-sheets-text span {
  font-weight: 600;
}
.file-info-container .blank-sheets-number {
  color: #259dff;
  text-align: right;
  font-family: "Barlow Semi Condensed";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.file-img {
  max-height: 65px;
  aspect-ratio: 46/65;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.2);
}
.file-name {
  font-family: "Barlow Semi Condensed";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.file-color {
  color: black;
  font-family: "Barlow Semi Condensed";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}
.file-pages {
  font-family: "Barlow Semi Condensed";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  color: #949494;
}
.coverTypeIcon {
  width: 20px;
  height: 20px;
}
.annotations-row > span {
  border-radius: 20px;
  padding: 4px 8px;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 14px;
  line-height: normal;
  font-weight: 500;
}
.annotations-row > span.blue {
  background-color: #d4ecff;
  color: #259dff;
}
.annotations-row > span.pink {
  color: #c80064;
  background-color: #ffd5eb;
}
.annotations-row > span.yellow {
  color: #d59b00;
  background-color: #fff0c6;
}
.noStock {
  color: #eb445a;
}
/*# sourceMappingURL=print-product-modal.component-L5VZKMCJ.css.map */
